import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlignRightComponent } from "./med-icon-align-right.component";

@NgModule({
  declarations: [
    MedIconAlignRightComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlignRightComponent,
  ],
})
export class MedIconAlignRightModule { }
